module.exports = __webpack_public_path__ + "img/ico_info_red.ff204aba.svg";